export default function Diferencial() {
  const diferenciais = [
    {
      icon: 'ri-medal-line',
      title: 'Expertise Técnica',
      description: '35 anos de know-how aplicado em cada projeto, do restauro de antiguidades à fabricação de peças minimalistas.'
    },
    {
      icon: 'ri-vip-crown-line',
      title: 'Curadoria de Materiais',
      description: 'Selecionamos apenas o que há de melhor em insumos, garantindo que a beleza do seu móvel seja acompanhada por uma estrutura robusta.'
    },
    {
      icon: 'ri-customer-service-2-line',
      title: 'Atendimento VIP',
      description: 'Consultoria técnica presencial em toda a Grande São Paulo, atendendo às necessidades específicas de cada cliente e arquiteto parceiro.'
    },
    {
      icon: 'ri-time-line',
      title: 'Cumprimento de Prazos',
      description: 'Sabemos que o tempo é o bem mais precioso em São Paulo. Trabalhamos com cronogramas rigorosos e transparência total.'
    }
  ];

  return (
    <section className="py-16 md:py-24 bg-white overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 sm:px-8">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            O Padrão de Qualidade que seu Projeto Exige.
          </h2>
          <p className="text-base sm:text-xl text-gray-600 max-w-3xl mx-auto">
            Descubra por que somos a escolha preferida em São Paulo
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
          {diferenciais.map((item, index) => (
            <div 
              key={index}
              className="relative bg-gradient-to-br from-gray-50 to-white p-6 sm:p-8 rounded-lg border border-gray-200 hover:border-emerald-500 transition-all duration-500 hover:shadow-xl hover:-translate-y-2 group overflow-hidden"
            >
              <div className="w-14 h-14 flex items-center justify-center bg-emerald-600 rounded-lg mb-5 group-hover:scale-110 transition-transform duration-300">
                <i className={`${item.icon} text-3xl text-white`}></i>
              </div>
              
              <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-3">
                {item.title}
              </h3>
              
              <p className="text-gray-600 leading-relaxed text-sm">
                {item.description}
              </p>

              <div className="absolute top-0 right-0 w-20 h-20 bg-emerald-600 opacity-5 rounded-bl-full"></div>
            </div>
          ))}
        </div>

        <div className="mt-14 md:mt-20 grid grid-cols-1 sm:grid-cols-3 gap-6 md:gap-8">
          <div className="relative rounded-lg overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-500 hover:scale-105">
            <div className="w-full h-60 sm:h-72">
              <img 
                src="https://public.readdy.ai/ai/img_res/ca79a224308187d258caa3c14621bf86.jpg"
                alt="Antes e Depois - Transformação 1"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent p-6">
              <p className="text-white font-semibold text-lg">Transformação Completa</p>
            </div>
          </div>

          <div className="relative rounded-lg overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-500 hover:scale-105">
            <div className="w-full h-60 sm:h-72">
              <img 
                src="https://readdy.ai/api/search-image?query=elegant%20antique%20armchair%20restored%20luxury%20upholstery%20velvet%20fabric%20classic%20vintage%20chair%20professional%20tapestry%20craftsmanship%20refined%20interior%20decor%20sophisticated%20furniture&width=500&height=400&seq=diferencial-restauro-poltrona-021&orientation=landscape"
                alt="Antes e Depois - Transformação 2"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent p-6">
              <p className="text-white font-semibold text-lg">Restauro de Antiguidades</p>
            </div>
          </div>

          <div className="relative rounded-lg overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-500 hover:scale-105">
            <div className="w-full h-60 sm:h-72">
              <img 
                src="https://readdy.ai/api/search-image?query=modern%20custom%20furniture%20creation%20process%20design%20to%20finished%20product%20bespoke%20upholstery%20work%20contemporary%20sofa%20manufacturing%20high-end%20craftsmanship%20luxury%20furniture%20production&width=500&height=400&seq=diferencial-sob-medida-010&orientation=landscape"
                alt="Antes e Depois - Transformação 3"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent p-6">
              <p className="text-white font-semibold text-lg">Móveis Sob Medida</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
